const inputPassword = () => {
  return import('@/pages/Invite/InputPassword')
}

export const inviteRoutes = [
  // 招待メールから遷移
  {
    path: '/account/register',
    name: 'inputPassword',
    component: inputPassword,
    props: route => ({ query: route.query.token }),
    meta: { requireAuth: false },
  },
]
